import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const Svg4VPavillion = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("switch", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", { d: "M38.141 9.859 24 4.001 9.859 9.859 4.001 24l5.858 14.142L24 43.999l14.141-5.857L43.998 24zM40.13 22.5H27.621l8.845-8.845zM25.5 7.871l8.845 3.664-8.845 8.844zm-3 12.508-8.844-8.845L22.5 7.871zm0 19.751-8.844-3.664 8.844-8.845zm3-12.509 8.845 8.845L25.5 40.13zM11.534 13.655l8.845 8.845H7.87zM7.87 25.5h12.509l-8.845 8.845zm28.596 8.845L27.621 25.5H40.13z" }) }) })
});
export default Svg4VPavillion;
